import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { useAppSelector } from 'store';

import { getUserProfileResult } from '../queries';
import { profileConst } from '..';

export const useUserProfileResult = () => {
  const { query } = useRouter();
  const userId = query?.id as string | undefined;
  const isAuthenticated = useAppSelector(({ authModal }) => authModal.isAuthenticated.status);

  return useQuery({
    queryKey: [profileConst.queryKeys.USER_PROFILE_RESULTS, userId || 'self'],
    queryFn: getUserProfileResult(userId),
    enabled: isAuthenticated
  });
};
